// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.0
//   protoc               v5.28.0
// source: channel/channel_kind.proto

/* eslint-disable */

/** Each kind of chat channel */
export enum ChannelKind {
  /** CHAT_ROOM - A chat root, i.e. a regular public channel */
  CHAT_ROOM = 0,
  /** DIRECT_MESSAGE - A direct message */
  DIRECT_MESSAGE = 1,
  UNRECOGNIZED = -1,
}

export function channelKindFromJSON(object: any): ChannelKind {
  switch (object) {
    case 0:
    case "CHAT_ROOM":
      return ChannelKind.CHAT_ROOM;
    case 1:
    case "DIRECT_MESSAGE":
      return ChannelKind.DIRECT_MESSAGE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChannelKind.UNRECOGNIZED;
  }
}

export function channelKindToJSON(object: ChannelKind): string {
  switch (object) {
    case ChannelKind.CHAT_ROOM:
      return "CHAT_ROOM";
    case ChannelKind.DIRECT_MESSAGE:
      return "DIRECT_MESSAGE";
    case ChannelKind.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
